import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import MCSLandingPageGenerator from "./mcs.generatorcontainer";
import axios from 'axios';
import { translate } from "../Services/translation";

export default function MCSImportExportContainer() {

    const activeChannelId = useSelector((state) => state.channel.activeChannelId);

    const [activeContainer, setActiveContainer] = useState(1);
    const [warning, setWarning] = useState("");
    const [importing, setImporting] = useState(false);
    const [importInfoText, setImportInfoText] = useState("");
    const [exporting, setExporting] = useState(false);
    const [exportInfoText, setExportInfoText] = useState("");

    const maxSize = 1073741824;


    const changeActiveContainer = (value) => {
        setActiveContainer(value);
    }

    const postImportFile = (file) => {
        setImporting(true);
        var formData = new FormData();
        formData.append("attachment", file)
        let url = '/api/mcs/import/' + activeChannelId;
        return axios.post(url, formData, { headers: { 'Content-type': 'multipart/formdata'}})
            .then(res => {
                if (res.data) {
                    setImporting(false);
                    setImportInfoText(translate("mcs.importedrules"));
                }
                let inputField = document.getElementById('mcs-import-input');
                inputField.value = null;
            })
    }

    const handleFile = (e, location) => {
        setImportInfoText('');
        e.stopPropagation();
        e.preventDefault();
        var file = e.target.files[0];
        if (file != null) {
            if (file.size <= maxSize) {
                if (location == "import") {
                    postImportFile(file);
                }
                else {
                    postUploadFile(file);
                }
            }
            else {
                setWarning(translate("mcs.filesizeerror"));
            }
        }
    }

    const exportRules = () => {
        setExportInfoText("");
        setExporting(true);
        let url = '/api/mcs/export/' + activeChannelId;
        axios({
            url: url,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            setExportInfoText(translate("mcs.exportedrules"))
            setExporting(false);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'MCS.xls');
            document.body.appendChild(link);
            link.click();
        });
    }

    return (
        <>
            <div className="mcs-settings-container center-container">
                <div className="row">
                    <div className="mcs-settings-container__settings-wrapper page-panel">
                        <div className="mcs-settings-container__topic-container col-6">
                            <ul className="mcs-settings-container__topic-list">
                                <li className={activeContainer == 1 ? "active no-select" : "no-select"} onClick={() => changeActiveContainer(1)}>{translate("mcs.import")}<i className="fas fa-chevron-right"></i></li>
                                <li className={activeContainer == 2 ? "active no-select" : "no-select"} onClick={() => changeActiveContainer(2)}>{translate("mcs.export")}<i className="fas fa-chevron-right"></i></li>
                                <li className={activeContainer == 3 ? "active no-select" : "no-select"} onClick={() => changeActiveContainer(3)}>{translate("mcs.generate")}<i className="fas fa-chevron-right"></i></li>
                            </ul>
                        </div>
                        <div className="mcs-settings-container__result-container col-6">
                            {activeContainer == 1 &&
                                <>
                                    <div className="mcs-settings-container__import-export-container">
                                        <div className="mcs-settings-container__import-export-wrapper import">
                                            <div className="mcs-settings-container__result-wrapper column">
                                                <h4>{translate("mcs.import")}</h4>
                                                <input type="file" id="mcs-import-input" disabled={importing} onChange={(event) => handleFile(event, "import")} />
                                                {importing && <i className="fas fa-cog fa-spin"></i>}
                                                {importInfoText && <span>{importInfoText}</span>}
                                            </div>
                                        </div>
                                        {warning && <div>{warning}</div>}
                                    </div>
                                </>
                            }
                            {activeContainer == 2 &&
                                <>
                                    <div className="mcs-settings-container__import-export-container">
                                        <div className="mcs-settings-container__import-export-wrapper import">
                                            <div className="mcs-settings-container__result-wrapper column">
                                                <button onClick={() => exportRules()} className="export-button">{translate("mcs.export")}</button>
                                                {exporting && <i className="fas fa-cog fa-spin"></i>}
                                                {exportInfoText && <span>{exportInfoText}</span>}
                                            </div>
                                        </div>
                                        {warning && <div>{warning}</div>}
                                    </div>
                                </>
                            }
                            {activeContainer == 3 &&
                                <>
                                    <MCSLandingPageGenerator />
                                </>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
